import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import LogoImage from 'src/assets/logo.svg';

// Link props (href, or component and to) decide where it goes. The logo is portrait, so only its
// height is fixed and the width follows from it. The image has an empty alt because the text below
// it already names the link.
const BrandLogo = ({ logoHeight, fontSize, ...linkProps }) => (
  <Link
    display="inline-flex"
    flexDirection="column"
    alignItems="center"
    gap={1}
    variant="body2"
    fontSize={fontSize}
    underline="hover"
    color="text.secondary"
    {...linkProps}>
    <img src={LogoImage} height={logoHeight} alt="" />
    <span>
      AppControl
      <Box component="span" color="primary.main">
        .ai
      </Box>
    </span>
  </Link>
);

export default BrandLogo;
